module.exports = __webpack_public_path__ + "static/lawadvisor-ventures--loop-01-6fe6609c3a26a48f08cc740f0dd02810.mp4";